import React, { useState, useEffect, SyntheticEvent } from "react";
import styles from "./sizeAutoItem.module.scss";
import classNames from "classnames";
import FmSlider from "@ui/basic/FmSlider";
import { FmImage } from "@/ui-component";

interface SizeAutoItemProps {
    img: string;
    title: string;
    leftTotal: number;
    rightTotal: number;
    leftVal: number;
    rightVal: number;
    id: number;
    onChange: Function;
}

const SizeAutoItem: React.FC<SizeAutoItemProps> = ({
    img,
    title,
    leftTotal,
    rightTotal,
    leftVal,
    rightVal,
    id,
    onChange,
}) => {
    const [state, setState] = useState({
        leftVal,
        rightVal,
        prop_leftVal: leftVal,
        prop_rightVal: rightVal,
    });

    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            leftVal,
            rightVal,
            prop_leftVal: leftVal,
            prop_rightVal: rightVal,
        }));
    }, [leftVal, rightVal]);

    const onMoveChange = (
        event: Event | SyntheticEvent<Element, Event>,
        newValue: number[] | number,
        activeThumb: number,
    ) => {
        if (Array.isArray(newValue)) {
            const [left, right] = newValue;
            setState((prevState) => ({
                ...prevState,
                leftVal: Math.ceil(
                    ((rightTotal - leftTotal) * left) / 100 + leftTotal,
                ),
                rightVal: Math.ceil(
                    rightTotal -
                        ((rightTotal - leftTotal) * (100 - right)) / 100,
                ),
            }));
        }
    };

    const onEndChange = (
        event: Event | SyntheticEvent<Element, Event>,
        value: number[] | number,
    ) => {
        if (Array.isArray(value)) {
            const [left, right] = value;
            onChange({
                id,
                leftVal: Math.ceil(
                    ((rightTotal - leftTotal) * left) / 100 + leftTotal,
                ),
                rightVal: Math.ceil(
                    rightTotal -
                        ((rightTotal - leftTotal) * (100 - right)) / 100,
                ),
            });
        }
    };

    const leftItemOffset =
        ((state.leftVal - leftTotal) / (rightTotal - leftTotal)) * 100;
    const rightItemOffSet =
        ((rightTotal - state.rightVal) / (rightTotal - leftTotal)) * 100;

    return (
        <div className={classNames(styles["filter-size-auto-container"])}>
            <div className={classNames(styles["line1"])}>
                <p>{title}</p>
                <FmImage image={img} alt={""} />
            </div>
            <FmSlider
                width={280}
                value={[leftItemOffset, 100 - rightItemOffSet]}
                onChange={onMoveChange}
                onChangeCommitted={onEndChange}
            />
            <div className={classNames(styles["line2"])}>
                <p>{state.leftVal}mm</p>
                <div className={classNames(styles["bar"])}></div>
                <p>{state.rightVal}mm</p>
            </div>
        </div>
    );
};

export default SizeAutoItem;
